import { createApp } from 'vue'
import App from './App.vue'
import './assets/sass/weber.scss'

createApp(App).mount('#app')
